export const calculateStats = (
  results,
  totalCost,
  totalEmissions,
  totalEnergyConsumed,
  points  
) => {
  const optimalCost = 6644;        // DKK
  const baselineCost = 8363;       // DKK
  
  const optimalEmissions = 1444000; // gCO₂ (≈ 1.38 t)
  const baselineEmissions = 1969000; // gCO₂ (≈ 1.69 t)
  
  const optimalEnergy = 11841;      // kWh
  const baselineEnergy = 14310;     // Energia consumata peggiore
  
  const maxComfortPoints = 27;


  const costScore = Math.min(
    100,
    Math.max(0, 100 * (1 - (totalCost - optimalCost) / (baselineCost - optimalCost)))
  );
  const emissionScore = Math.min(
    100,
    Math.max(0, 100 * (1 - (totalEmissions - optimalEmissions) / (baselineEmissions - optimalEmissions)))
  );
  const energyScore = Math.min(
    100,
    Math.max(0, 100 * (1 - (totalEnergyConsumed - optimalEnergy) / (baselineEnergy - optimalEnergy)))
  );
  // Normalizza il punteggio di comfort in base ai punti raccolti
  const comfortScore = Math.min(
    100,
    Math.max(0, 100 * (points  / maxComfortPoints))
  );

  // Combina i punteggi. Qui usiamo un peso uguale per ciascuno dei quattro componenti:
  const finalScore = (costScore *0.25 + emissionScore  * 0.25 + comfortScore * 0.5) ;

  return {
    costScore: costScore.toFixed(2),
    emissionScore: emissionScore.toFixed(2),
    energyScore: energyScore.toFixed(2),
    comfortScore: comfortScore.toFixed(2),
    finalScore: finalScore.toFixed(2)
  };
};
